import { SectionHead, Reveal } from "@/components/Reveal";
import { STATS } from "@/data/content";

export default function Stats() {
    return (
        <section className="relative border-t border-white/10 bg-void py-28 md:py-36" data-testid="stats-section">
            <div className="mx-auto max-w-[1400px] px-5 md:px-10">
                <SectionHead
                    number="06"
                    label="Why automation?"
                    title="The research is not subtle."
                    copy="Independent research on speed-to-lead, conversion and response times. Every figure is sourced — we don't invent numbers, and we don't promise guaranteed multiples."
                />
                <div className="mt-16 grid grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
                    {STATS.map((s, i) => (
                        <Reveal key={s.value + i} delay={(i % 3) * 0.08} y={16}>
                            <div className="flex h-full flex-col bg-void p-8 transition-colors duration-300 hover:bg-surface md:p-10" data-testid={`stat-card-${i}`}>
                                <p className="font-display text-5xl font-black tracking-tighter text-white">{s.value}</p>
                                <p className="mt-4 flex-1 text-sm font-light leading-relaxed text-white/55">{s.text}</p>
                                <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-white/35">Source — {s.source}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.2}>
                    <p className="mt-8 max-w-3xl text-sm font-light leading-relaxed text-white/45">
                        What HIGHTS builds is designed around these realities: systems that increase visibility,
                        capture more enquiries, respond in seconds and automate the repetitive journeys in between.
                        Verified HIGHTS client results will be published here as evidence is gathered — not before.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
